export const languages = Object.freeze({
  INGLESE: 'inglese',
  FRANCESE: 'francese',
  TEDESCO: 'tedesco',
  SPAGNOLO: 'spagnolo',
  ALTRO: 'altro',
})
